import CustomDrawer from "../shared/CustomDrawer";
import { useEffect, useState } from "react";
import { Box, Button, IconButton, TextField, Typography } from "@mui/material";
import moment from "moment-jalaali";
import MultiPicker from "rmc-picker/lib/MultiPicker";
import Picker from "rmc-picker/lib/Picker";
import "rmc-picker/assets/index.css";
import "./date-picker.css";

export function SetBirthDateBottomSheet(props) {
  const { open, setOpen, birthDate, setBirthDate } = props;

  const [editableDate, setEditableDate] = useState(
    birthDate
      ? moment(birthDate).format("jDD jMM jYYYY").split(" ")
      : moment().format("jDD jMM jYYYY").split(" ")
  );

  useEffect(() => {
    setEditableDate(
      moment(birthDate ? birthDate : undefined)
        .format("jDD jMM jYYYY")
        .split(" ")
    );
  }, [birthDate]);

  const onChange = (value) => {
    setEditableDate(value);
  };

  return (
    <CustomDrawer
      open={open}
      onClose={() => {
        setEditableDate(
          moment(birthDate ? birthDate : undefined)
            .format("jDD jMM jYYYY")
            .split(" ")
        );
        setOpen(false);
      }}
    >
      <MultiPicker selectedValue={editableDate} onValueChange={onChange}>
        <Picker indicatorClassName="my-picker-indicator">
          {Array.apply(null, Array(31)).map((item, index) => {
            return (
              <Picker.Item
                key={index}
                className="my-picker-view-item"
                value={("00" + (index + 1).toString()).slice(-2)}
              >
                {index + 1}
              </Picker.Item>
            );
          })}
        </Picker>
        <Picker indicatorClassName="my-picker-indicator">
          {[
            { title: "فروردین", value: "01" },
            { title: "اردیبهشت", value: "02" },
            { title: "خرداد", value: "03" },
            { title: "تیر", value: "04" },
            { title: "مرداد", value: "05" },
            { title: "شهریور", value: "06" },
            { title: "مهر", value: "07" },
            { title: "آبان", value: "08" },
            { title: "آذر", value: "09" },
            { title: "دی", value: "10" },
            { title: "بهمن", value: "11" },
            { title: "اسفند", value: "12" },
          ].map((item) => {
            return (
              <Picker.Item
                key={item.value}
                className="my-picker-view-item"
                value={item.value}
              >
                {item.title}
              </Picker.Item>
            );
          })}
        </Picker>
        <Picker indicatorClassName="my-picker-indicator">
          {Array.apply(null, Array(200)).map((item, index) => {
            return (
              <Picker.Item
                key={index}
                className="my-picker-view-item"
                value={(index + 1300).toString()}
              >
                {index + 1300}
              </Picker.Item>
            );
          })}
        </Picker>
      </MultiPicker>
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          justifyContent: "flex-end",
        }}
      >
        <Button
          onClick={() => setOpen(false)}
          variant="text"
          size="small"
          sx={{ color: "grey.3" }}
        >
          لغو
        </Button>
        <Button
          onClick={() => {
            setBirthDate(
              moment(editableDate.join("/"), "jDD/jMM/jYYYY").format(
                "YYYY-MM-DD"
              )
            );
            setOpen(false);
          }}
          variant="contained"
          size="small"
          color="primary"
          sx={{ color: "common.white" }}
        >
          تایید
        </Button>
      </Box>
    </CustomDrawer>
  );
}
